import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersTransactionLogsQuery } from '../store/services/customers';

const ProblemNostroTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    customersProblemTransactions: {
      nostro: { logs },
    },
    customersDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const [getNostroLogs, { isLoading }] =
    useLazyGetCustomersTransactionLogsQuery();

  const getNostroLogsAction = useCallback(() => {
    getNostroLogs(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!logs && transactionId) {
      getNostroLogsAction();
    }
  }, [getNostroLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_NOSTRO_LIST,
      )}
    />
  );
};

export default ProblemNostroTransactionLogContentHOC;
